if (!customElements.get('pf-bird-kit')) {
  customElements.define('pf-bird-kit', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.t = this.config.text;
      this.sizes = {XS:[1,1,'13¼','12'],S:[1,1,'16','14¾'],M:[2,1,'20','18¼'],L:[2,2,'23','21'],XL:[3,2,'25¾','23½']};
      this.size = this.querySelector('[data-size]');
      this.colors = ['A','B'].map(g=>this.querySelector('[data-color="'+g+'"]'));
      this.button = this.querySelector('[data-add]');
      this.error = this.querySelector('[data-error]');
      this.status = this.querySelector('[data-status]');
      this.money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.config.currency || 'USD'}).format(n/100);
      this.querySelector('[data-cart-link]').addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();window.location.assign(this.dataset.cart);});
      this.addEventListener('change',()=>{this.status.textContent='';this.render();});
      this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();this.add();});
      this.render();
    }
    selection() {
      const size=this.sizes[this.size.value];
      return this.colors.map((select,i)=>({variant:this.config.variants.find(v=>String(v.id)===select.value),quantity:size[i],group:['A','B'][i]}));
    }
    render() {
      const size=this.sizes[this.size.value], rows=this.selection(), totals=new Map();
      rows.forEach(r=>{if(r.variant) totals.set(r.variant.id,(totals.get(r.variant.id)||0)+r.quantity);});
      const first=this.config.variants.find(v=>v.available);
      let yarnPrice=0,stockOK=true;
      rows.forEach((r,i)=>{
        this.querySelector('[data-quantity="'+r.group+'"]').textContent='('+r.quantity+' '+(r.quantity===1?this.t.hank:this.t.hanks)+')';
        yarnPrice+=(r.variant || first || {price:0}).price*r.quantity;
        const img=this.querySelector('[data-swatch="'+r.group+'"]');
        img.hidden=!r.variant?.image;
        if(r.variant?.image){img.src=r.variant.image;img.alt=r.variant.title;}
        if(r.variant && (!r.variant.available || (r.variant.tracked && r.variant.policy!=='continue' && totals.get(r.variant.id)>r.variant.quantity))) stockOK=false;
        Array.from(this.colors[i].options).forEach(opt=>{
          if(!opt.value)return;
          const v=this.config.variants.find(v=>String(v.id)===opt.value);
          const other=rows[1-i];
          const required=r.quantity+(other.variant?.id===v.id?other.quantity:0);
          opt.disabled=!v.available || Boolean(v.tracked && v.policy!=='continue' && required>v.quantity);
        });
      });
      this.total=yarnPrice+this.config.pattern.price;
      this.querySelectorAll('[data-total]').forEach(el=>el.textContent=this.money(this.total));
      this.querySelector('[data-yarn-summary]').textContent=(size[0]+size[1])+' '+this.t.yarn_summary;
      this.querySelector('[data-yarn-total]').textContent=this.money(yarnPrice);
      this.querySelector('[data-pattern-total]').textContent=this.money(this.config.pattern.price);
      this.querySelector('[data-fit]').textContent=this.t.chest+': '+size[2]+'″ · '+this.t.back+': '+size[3]+'″';
      this.valid=rows.every(r=>r.variant) && stockOK && this.config.pattern.available;
      this.error.textContent=!this.config.pattern.available?this.t.unavailable:!stockOK?this.t.stock:'';
      this.button.disabled=!this.valid || this.busy;
    }
    async add() {
      if(this.busy || !this.valid)return;
      this.busy=true;this.button.disabled=true;this.button.textContent=this.t.adding;this.error.textContent='';
      try {
        const before=await fetch(this.dataset.root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw Error();return r.json();});
        const products=await Promise.all([this.config.yarnHandle,this.config.patternHandle].map(h=>fetch(this.dataset.root+'products/'+h+'.js').then(r=>{if(!r.ok)throw Error();return r.json();})));
        const rows=this.selection(), need=new Map();
        rows.forEach(r=>need.set(r.variant.id,(need.get(r.variant.id)||0)+r.quantity));
        for(const row of rows){
          const live=products[0].variants.find(v=>v.id===row.variant.id);
          if(!live?.available)throw Error(this.t.unavailable);
          row.variant.price=live.price;
          const inCart=before.items.filter(i=>i.variant_id===row.variant.id).reduce((n,i)=>n+i.quantity,0);
          if(row.variant.tracked && row.variant.policy!=='continue' && need.get(row.variant.id)+inCart>row.variant.quantity)throw Error(this.t.stock);
        }
        const pattern=products[1].variants.find(v=>v.id===this.config.pattern.id);
        if(!pattern?.available)throw Error(this.t.unavailable);
        const old=this.total;this.config.pattern.price=pattern.price;this.render();
        if(old!==this.total)throw Error(this.t.changed);
        const token='bird-'+Date.now()+'-'+Math.random().toString(36).slice(2,8);
        const props={Kit:'Bird Island Dog Sweater',Size:this.size.value,_pf_kit:token};
        const items=rows.map(r=>({id:r.variant.id,quantity:r.quantity,properties:{...props,'Pattern color':r.group}}));
        items.push({id:pattern.id,quantity:1,properties:{...props,Component:'Pattern'}});
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok)throw Error(result.description || this.t.failed);
        const cart=await fetch(this.dataset.root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw Error();return r.json();});
        const lines=cart.items.filter(i=>i.properties?._pf_kit===token);
        if(lines.reduce((n,i)=>n+i.quantity,0)!==rows[0].quantity+rows[1].quantity+1)throw Error(this.t.failed);
        const charged=lines.reduce((n,i)=>n+i.final_line_price,0);
        this.status.textContent=this.t.added+' '+this.money(charged);
        this.querySelector('[data-cart-link]').hidden=false;
        this.dispatchEvent(new CustomEvent('pf:kit-added',{bubbles:true,detail:{cart}}));
      } catch(error) {
        this.error.textContent=error.message || this.t.failed;
        this.querySelector('[data-cart-link]').hidden=false;
      } finally {
        this.busy=false;this.button.disabled=!this.valid;this.button.textContent=this.t.add;
      }
    }
  });
}
